import clsx from "clsx";
import { useDragDrop } from "../../hooks/useDragDrop";
import ScrollableContainer from "./ScrollableContainer";

export const AdminDragdropItem = ({
  index,
  moveItem,
  onDrop,
  isAdminMode,
  children,
  className,
}: {
  index: number;
  isAdminMode: boolean;
  children: React.ReactNode;
  className?: string;
} & TDdItemProps) => {
  return (
    <>
      {isAdminMode ? (
        <Item
          index={index}
          moveItem={moveItem}
          onDrop={onDrop}
          className={className}
        >
          {children}
        </Item>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

const Item = ({
  index,
  moveItem,
  onDrop,
  children,
  className,
}: {
  index: number;
  children: React.ReactNode;
  className?: string;
} & TDdItemProps) => {
  const { ddRef, isOver, isDragging } = useDragDrop({
    index,
    moveItem,
    onDrop,
  });
  return (
    <>
      <div
        className={clsx(
          className ? className : "cursor-move select-none",
          "transition-all duration-150",
          isDragging &&
            "z-20 border-2 border-blue-400 bg-blue-50 opacity-80 shadow-lg",
          isOver && !isDragging && "relative z-10 opacity-50",
        )}
        ref={ddRef}
        style={{
          minHeight: 40,
          position: "relative",
          ...(isDragging ? { pointerEvents: "none" } : {}),
        }}
      >
        {/* Placeholder when dragging over */}
        {isOver && !isDragging && (
          <div
            className="pointer-events-none absolute left-0 right-0 top-0 h-2 rounded bg-blue-200"
            style={{ zIndex: 10 }}
          />
        )}
        {children}
      </div>
      {isDragging && <ScrollableContainer />}
    </>
  );
};
